import { useScrollToTop } from "../../../api/hooks/use.scroll.to.top";

export const ScrollToTop: React.FC = () => {
  useScrollToTop();
  return null;
};